import React from "react";

export const Solution = (props) => {
  return (
    <div id="solution" className="solution-section">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column: Image */}
          <div
            className="col-md-5"
            data-aos="fade-right"
            data-aos-duration="2000"
            data-aos-easing="ease-in-out"
          >
            <div className="solution-image">
              <img
                src="img/Business+solutions.jpeg"
                alt="Andrew Wright"
                className="img-responsive rounded shadow-lg custom-image"
              />
            </div>

          </div>

          {/* Right Column: Content */}
          <div
            className="col-md-7"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
          >
            <div className="solution-content">
              <h2
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="200"
              >
                {props.data ? props.data.title : "Loading..."}
              </h2>
              <h4
                className="solution-intro"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="400"
              >
                {props.data ? props.data.intro : "Loading..."}
              </h4>
              <p
                className="solution-text"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay="600"
              >
                {props.data ? props.data.paragraph : "Loading..."}
              </p>

              <div className="solution-credentials row">
                {props.data
                  ? props.data.credentials.map((d, i) => (
                    <div
                      key={`${d}-${i}`}
                      className="col-sm-6"
                      data-aos="zoom-in"
                      data-aos-duration="500"
                      data-aos-delay={800 + i * 200} // har box thoda delay se
                    >
                      <div className="credential-box">
                        <i className="fa fa-check-circle"></i>
                        <span style={{ fontSize: "16px" }}>{d}</span>
                      </div>
                    </div>
                  ))
                  : "Loading..."}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
